<template>
    <section v-if="hasPermissions(['Assignment-Shift Read', 'Assignment-Shift Write', 'Assignment-Shift Shift-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text" v-html="`This is the main view for Shifts. To view and manage breaks, click into an individual Shift record's description name.`"/>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="shifts.length && hasPermissions(['Assignment-Shift Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'shift_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Assignment-Shift Shift-Upload'])"
                />
                <button v-if="hasPermissions(['Assignment-Shift Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Assignment-Shift Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="shifts.length && hasPermissions(['Assignment-Shift Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="shifts"
                                :search="search"
                                :checkable="true"
                                :link="child_href"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Shift'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Shift Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'shifts_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

        <DeletionValidationModal 
        :validation_table_headers="deletion_validation_table_headers"
        :validate_data="validate_data"
        :breadcrumb="breadcrumb"
        message="The following shifts were not deleted because there are daily assignments linked to them. Please note that these daily assignments may also be linked to items in the recycle bin."
        />

    </section>
     <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import FormResources        from    './form_resources'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import DeletionValidationModal          from    '@/components/DeletionValidationModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import HelperModal          from    '@/components/HelperModal'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue

const notyf = new Notyf({
    duration: 8000,
});
export default {

    name: 'Shift',

    components: {
      Breadcrumb,
      WaitingModal,
      DeletionModal,
      FormModal,
      UpdateModal,
      DinamicTable,
      DeletionMassiveModal,
      UploadOptions,
      UploadSummary,
      UnauthorizedComponent,
      DeletionValidationModal,
      HelperModal
    },
    data() {
      return {
        notyf,
        user:               this.get_user(),
        child_href:         '/assignment-shifts/',
        title_page:         'Shifts',
        content_header:     this.$store.state.headers,
        rest_api:           `shifts`,
        notifications:      this.$store.state.form_notyf,
        table_headers:      Resources.table_headers,
        breadcrumb:         Resources.breadcrumb,
        excel_file_headers: Resources.excel_file_headers,
        empty_format_data:  Resources.empty_format_data,
        shift_options:      FormResources.shift_options,
        deletion_validation_table_headers: Resources.deletion_validation_table_headers,
        add_btn:            'Add Shift',
        single_select:      false,
        table_selection:    [],
        search:             '',
        global_index:       null,
        single_object:      {},
        shifts:             [],
        array_options:      {},
        select_ids:         [],
        summary:                [],
        excel_data:             [],
        helps:              Resources.helps,
        validate_data: []
      }
    },
    methods: {

        timeConvertion(hour)
        {
            let hour_split = hour.split(":");
            let currenthour = parseInt(hour_split[0], 10)
            let total_minutes = currenthour * 60
            return total_minutes
        },

        format_number(value)
        {
            return Number(value) ? Number(value) : ''
        },

        unshift_object(new_object)
        {
            this.shifts.unshift(new_object)
            this.updateWorkTime()
        },

        splice_object(splicing_object)
        {
            this.shifts.splice(splicing_object.index, 1, splicing_object.single_object)
            this.updateWorkTime()
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.shifts[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.shifts[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.shifts = data.shifts
            this.updateWorkTime()

        },

        updateWorkTime()
        {
            // this.shifts.map((item) => {

            //     item['break_length'] = item.break_length.length ? this.sumArrays(item.break_length) : 0

            //     let decrease_time = this.minutesCounter( item.total_time, item['break_length'], true )

            //     item['work_time'] = this.timeAsMinutes(decrease_time)

            // })
        },

        trashing(index)
        {
            this.shifts.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.shifts.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            this.loader(true)

            let response = await this.post(`${this.rest_api}/massive_delete`, json_request)

            this.loader()

            if(response)
            {
                const validation_data = response.data.validated_shifts

                if(validation_data.length)
                {
                    window.$('#deletion-validations').modal('show')
                    this.validate_data = validation_data
                }

                window.$('#static-deletion-massive').modal('hide')

                response.data.deleted_ids.forEach( item =>
                {
                    const index = this.shifts.findIndex(value => value.decrypted_id == item)
                    if(index > -1)
                    {
                        this.shifts.splice(index, 1)
                    }
                })

                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}
                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const class_option = this.array_options.class.find(item => item.name == entity.class)
                entity.class = class_option ? class_option.id : null

                if(entity.start_time || entity.end_time) {
                    this.total_time_calculation(entity.start_time, entity.end_time, entity)
                }

                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { shifts: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                for (const shift of response.data.shifts) {
                    this.unshift_object(shift);
                }
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },

        total_time_calculation(start_time, end_time, entity)
        {
            start_time  = start_time.split(":")
            end_time    = end_time.split(":")
            let start_date  = new Date(0, 0, 0, start_time[0], start_time[1], 0)
            let end_date    = new Date(0, 0, 0, end_time[0], end_time[1], 0)
            let diff        = end_date.getTime() - start_date.getTime()
            let hours       = Math.floor(diff / 1000 / 60 / 60)
            let result      = diff - hours * 1000 * 60 * 60
            let minutes     = Math.floor(result / 1000 / 60)
            if (hours < 0) 
            {
                hours = hours + 24
            }
            entity.total_time = `${hours <= 9 ? "0" : ""}${hours}:${minutes <= 9 ? "0" : ""}${minutes}`
        },
    },

    async mounted() 
    {
        if(this.hasPermissions(['Assignment-Shift Read']))
        {
            await this.api_request()
        }
        this.array_options = {
            class: this.shift_options
        }
        console.log(this.array_options)
    },

    computed:
    {
        selected()
        {
            const bool = this.shifts.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>